import { NetworkId } from 'modules/network';
import { ProgramId } from 'modules/program';
import { Tracking } from 'modules/tracking';

const SearchWidgetTrackings: Record<ProgramId, Record<NetworkId, Tracking>> = {
  // Abritel
  abritel: {
    pz: {
      id: 'abritel',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: '1100l98372',
    },
  },

  // Bookabach
  'nz-bookabach': {
    pz: {
      id: 'nz-bookabach',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: '1101l98908',
    },
  },

  // Expedia
  'au-expedia': {
    pz: {
      id: 'au-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l86802',
    },
  },
  'ca-expedia': {
    pz: {
      id: 'ca-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l87345',
    },
  },
  'de-expedia': {
    pz: {
      id: 'de-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l87346',
    },
  },
  'fr-expedia': {
    pz: {
      id: 'fr-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l86769',
    },
  },
  'hk-expedia': {
    pz: {
      id: 'hk-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1011l87784',
    },
  },
  'jp-expedia': {
    pz: {
      id: 'jp-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l87350',
    },
  },
  'kr-expedia': {
    pz: {
      id: 'kr-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1011l87783',
    },
  },
  'mx-expedia': {
    pz: {
      id: 'mx-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l87104',
    },
  },
  'nz-expedia': {
    pz: {
      id: 'nz-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1011l87787',
    },
  },
  'sg-expedia': {
    pz: {
      id: 'sg-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1011l87785',
    },
  },
  'uk-expedia': {
    pz: {
      id: 'uk-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1011l87748',
    },
  },
  'us-expedia': {
    pz: {
      id: 'us-expedia',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1101l81954',
    },
  },

  // FeWo-direkt
  'fewo-direkt': {
    pz: {
      id: 'fewo-direkt',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: '1100l98373',
    },
  },

  // Hotels
  'au-hcom': {
    pz: {
      id: 'au-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1101l68327',
    },
  },
  'br-hcom': {
    pz: {
      id: 'br-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1011l87795',
    },
  },
  'ca-hcom': {
    pz: {
      id: 'ca-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1011l68410',
    },
  },
  // 'de-hcom': {
  //   pz: {
  //     id: 'de-hcom',
  //     baseUrl: 'https://hotels.prf.hn/click',
  //     creativeRef: '1011l102022',
  //   },
  // },
  'dk-hcom': {
    pz: {
      id: 'dk-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1101l87355',
    },
  },
  'fi-hcom': {
    pz: {
      id: 'fi-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1011l87793',
    },
  },
  'fr-hcom': {
    pz: {
      id: 'fr-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1011l88335',
    },
  },
  // 'is-hcom': {
  //   pz: {
  //     id: 'is-hcom',
  //     baseUrl: 'https://hotels.prf.hn/click',
  //     creativeRef: '1011l88336',
  //   },
  // },
  'jp-hcom': {
    pz: {
      id: 'jp-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1100l86811',
    },
  },
  'kr-hcom': {
    pz: {
      id: 'kr-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1101l87354',
    },
  },
  'mx-hcom': {
    pz: {
      id: 'mx-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1100l87329',
    },
  },
  'no-hcom': {
    pz: {
      id: 'no-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1100l86813',
    },
  },
  'se-hcom': {
    pz: {
      id: 'se-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1100l86814',
    },
  },
  'tw-hcom': {
    pz: {
      id: 'tw-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1100l86818',
    },
  },
  'uk-hcom': {
    pz: {
      id: 'uk-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1011l68409',
    },
  },
  'us-hcom': {
    pz: {
      id: 'us-hcom',
      baseUrl: 'https://hotels.prf.hn/click',
      creativeRef: '1011l66576',
    },
  },

  // Stayz
  'au-stayz': {
    pz: {
      id: 'au-stayz',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: '1100l98375',
    },
  },

  // Vrbo
  // 'at-vrbo': {
  //   pz: {
  //     id: 'at-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'au-vrbo': {
  //   pz: {
  //     id: 'au-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'br-vrbo': {
  //   pz: {
  //     id: 'br-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  'ca-vrbo': {
    pz: {
      id: 'ca-vrbo',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: '1011l99282',
    },
  },
  // 'dk-vrbo': {
  //   pz: {
  //     id: 'dk-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'es-vrbo': {
  //   pz: {
  //     id: 'es-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'fi-vrbo': {
  //   pz: {
  //     id: 'fi-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'gr-vrbo': {
  //   pz: {
  //     id: 'gr-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'it-vrbo': {
  //   pz: {
  //     id: 'it-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'jp-vrbo': {
  //   pz: {
  //     id: 'jp-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'mx-vrbo': {
  //   pz: {
  //     id: 'mx-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'nl-vrbo': {
  //   pz: {
  //     id: 'nl-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'no-vrbo': {
  //   pz: {
  //     id: 'no-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'nz-vrbo': {
  //   pz: {
  //     id: 'nz-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'pl-vrbo': {
  //   pz: {
  //     id: 'pl-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'pt-vrbo': {
  //   pz: {
  //     id: 'pt-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'se-vrbo': {
  //   pz: {
  //     id: 'se-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  // 'sg-vrbo': {
  //   pz: {
  //     id: 'sg-vrbo',
  //     baseUrl: 'https://vrbo.prf.hn/click',
  //     creativeRef: null,
  //   },
  // },
  'uk-vrbo': {
    pz: {
      id: 'uk-vrbo',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: '1101l98909',
    },
  },
  'us-vrbo': {
    pz: {
      id: 'us-vrbo',
      baseUrl: 'https://vrbo.prf.hn/click',
      creativeRef: '1100l98376',
    },
  },

  // Wotif
  'au-wotif': {
    pz: {
      id: 'au-wotif',
      baseUrl: 'https://prf.hn/click',
      creativeRef: '1100l86815',
    },
  },
};

export { SearchWidgetTrackings };
